import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import InputIcon from '@mui/icons-material/Input';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import BoolSetting from "../../../../../../../components/global/Settings/BoolSetting";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import { useGetEnumsQuery, useGetSettingsQuery } from "../../../../../../../newapi/global/generalApiSlice";
import NumberSetting from "../../../../../../../components/global/Settings/NumberSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";

const WareHouseDropdown = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        height: 40,
        background:
          theme.palette.mode === "dark"
            ? colors.grey["400"]
            : colors.txt["primary"],
        borderRadius: 5,
        paddingX: 2,
        paddingRight: 1,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        color: "#fff",
      }}
    >
      <Box>
        <Text bold variant="blue">
          All
        </Text>
        &nbsp;<Text variant="white">Warehouses</Text>
      </Box>
      <KeyboardArrowDownIcon />
    </Box>
  );
};

const Echeck = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [showTimer, setShowTimer] = useState(false);
  // Finalizing with Enter only makes sense when nothing finalizes automatically.
  const [autoFinalizeOff, setAutoFinalizeOff] = useState(false);
  const [view, setView] = useState({
    title: 'replenish',
    icon: <InputIcon />,
    topRight: <WareHouseDropdown />,
  });

  

  const { data: settings} = useGetSettingsQuery("echeck");
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  const { data: globalEnums, enumIsLoading } = useGetEnumsQuery();
  
  useEffect(() => {
    props.replaceView({
        ...props.config,
        topRight: <WareHouseDropdown />,
    },);

    return () => {};
  }, []);

useEffect(() => {
    const autoSetting = settings?.find((setting) => setting.key === "echeck_auto_finalize");
    setShowTimer(autoSetting?.value === "timer")
    setAutoFinalizeOff(autoSetting?.value === "false")
  }, [settings])

  return (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 4,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            // background:"purple",
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_echeck_heading")}</Subheading>
            <Text light>{t("core_echeck_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>

        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
              // display:"none"
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              padding: 3,
              display:"flex",
              flexDirection:"column",
              gap:3,
              borderTopRightRadius:16,
              borderTopLeftRadius:16,
            }}
          >
            {/* <BoolSetting manualSave onChange={handleChange} settings={settings} skey="echeck_auto_finalize"/> */}
            <DropdownSetting 
              manualSave
              onChange={(value, setting) => {
                handleChange(value, setting);
                setShowTimer(value === "timer");
                setAutoFinalizeOff(value === "false");
              }}
              settings={settings} 
              objects={[
                {
                id: "false",
                value: "false",
                name: t("no")
                },
                {
                  id: "true",
                  value: "true",
                  name: t("yes")
                },
                {
                  id: "timer",
                  value: "timer",
                  name: t("echeck_timer")
                }
              ]} 
              noselection={"choose_type"}
              variant={"default"} 
              skey="echeck_auto_finalize"
            />
            {showTimer && 
            <NumberSetting manualSave hideSaveButton onChange={handleChange} settings={settings} skey="echeck_timer_amount"/>}
            <BoolSetting manualSave disabled={!autoFinalizeOff} onChange={handleChange} settings={settings} skey="echeck_finalize_on_enter"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="echeck_confirm_order_from_sidepanel"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_carrier_mandatory"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_confirm_for_product_row_click"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_view_stocks_in_order_processing"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_view_pickinglines_in_order_processing"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_show_virtual_product"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_sound_when_scanning"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_sound_when_wrong_scan"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_popup_for_outbound_instructions"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_popup_for_b2b_order"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_open_singles_modal_on_scan"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_confirm_product_amount"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_finalize_without_label"/>
            {/* UNCOMMENT WHEN BACKEND HAS BEEN MADE */}
            {/* <BoolSetting manualSave onChange={handleChange} settings={settings}  skey="echeck_can_create_standalone_shipment"/> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Echeck;
